import { render, staticRenderFns } from "./CustomLogoSlider.vue?vue&type=template&id=75f18dd7&scoped=true"
import script from "./CustomLogoSlider.vue?vue&type=script&lang=js"
export * from "./CustomLogoSlider.vue?vue&type=script&lang=js"
import style0 from "./CustomLogoSlider.vue?vue&type=style&index=0&id=75f18dd7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f18dd7",
  null
  
)

export default component.exports